import { Button, Spin, Upload } from 'antd';
import styled from 'styled-components';

import { Form } from '@components/Form';
import { TextArea } from '@components/Input';
import { Label } from '@components/Label';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { Select } from '@components/Select';
import { UnstyledButton } from '@components/UnstyledButton/UnstyledButton';

export const StyledAttachmentsContainer = styled.div`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: -12px;

  .preview {
    display: flex;
    flex-direction: column;

    .img-container {
      width: 80px;
      height: 110px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;

export const StyledCloseButton = styled(UnstyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: ${({ theme }) => theme.palette.color[0]};
  border-radius: 50%;
  position: relative;
  left: calc(100% - 12px);
  top: 12px;

  svg {
    path {
      stroke: #ffffff;
    }
  }
`;

export const StyledUpload = styled(Upload)`
  &.ant-upload-wrapper {
    .ant-upload {
      width: 100%;
      .ant-upload {
        width: 100%;
        .ant-btn {
          width: 100%;
        }
      }
    }
  }
`;
export const StyledSpin = styled(Spin)`
  &.ant-spin {
    padding: 6px 0;
  }
`;
export const StyledUploadButton = styled(Button)`
  width: 472px;
  height: 124px;
  border: 1px dashed #bababa;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const StyledSelect = styled(Select)`
  &.ant-select {
    &.ant-select-multiple {
      .ant-select-selector {
        padding: 0 22px 0 11px;
        @media (max-width: 768px) {
          padding: 0 30px 0 15px;
          min-height: 40px;
          height: auto;
        }
        .ant-select-selection-search {
          margin: 0;
        }
      }
      .ant-select-selection-placeholder {
        inset-inline-start: 11px;
        @media (max-width: 768px) {
          inset-inline-start: 15px;
        }
      }
    }
    .ant-select-selector {
      border-radius: 4px;
      @media (max-width: 768px) {
        height: 40px;
        padding: 0 15px;
      }

      .ant-select-selection-item {
        line-height: 30px;
        display: flex;
        align-items: center;
        @media (max-width: 768px) {
          font-size: 16px;
          line-height: 38px;
        }
      }

      .ant-select-selection-search {
        .ant-select-selection-search-input {
          @media (max-width: 768px) {
            height: 38px;
            font-size: 16px;
          }
        }
      }
      .ant-select-selection-placeholder {
        @media (max-width: 768px) {
          line-height: 38px;
          font-size: 16px;
        }
      }
    }
    .ant-select-arrow {
      svg {
        path {
          stroke: ${({ theme }) => theme.palette.greyscale[8]};
        }
      }
    }
  }

  &.ant-select-dropdown {
    .ant-select-item {
      @media (max-width: 768px) {
        padding: 7px 15px;
      }
      .ant-select-item-option-content {
        @media (max-width: 768px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
`;

export const StyledForm = styled(Form)`
  &.ant-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const StyledTextArea = styled(TextArea)`
  &.ant-input {
    height: 32px;
    border: 1px solid ${({ theme }) => theme.palette.border[5]};
    height: 32px;
    padding: 7px 11px;

    @media (max-width: 768px) {
      height: 40px;
      padding: 7px 15px;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const StyledFormItem = styled(Form.Item)`
  &.ant-form-item {
    margin-bottom: 0;
    .ant-form-item-row {
      .ant-form-item-control {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .ant-form-item-explain-error {
          margin: 0;
          line-height: 16px;

          @media (max-width: 768px) {
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
    }
  }
`;

export const StyledLoadingSpinner = styled(LoadingSpinner)`
  height: 100%;
  span.anticon {
    svg {
      width: 20px;
      height: auto;
    }
  }
`;

export const StyledLabel = styled(Label)`
  &.ant-typography {
    color: ${({ theme }) => theme.palette.text[0]};
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const StyledImageContainer = styled.div`
  width: 100%;
  height: 216px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
